import { CircularProgress, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { MdsRedoXs } from "@sinch/icons";
import { enqueueSnackbar } from "notistack";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { MdsIcon } from "@sinch/components";
import { useAttendance } from "@sinch/components/application/Attendace/useAttendance";

interface ResendInvitationMenuItemProps {
  loading: boolean;
  handleClose: () => void;
  attendanceId: string;
  onLoading?: (loading: boolean) => void;
}

export const ResendInvitationMenuItem: FC<ResendInvitationMenuItemProps> = ({
  loading,
  handleClose,
  attendanceId,
  onLoading,
}) => {
  const { t } = useTranslation();
  const { resendInvitation } = useAttendance();

  const handleResendInvitation = async () => {
    onLoading?.(true);
    try {
      await resendInvitation(attendanceId, true);
    } catch (e) {
      console.error(e);
      enqueueSnackbar(t("Error.anErrorHasOccurred"), { variant: "error" });
    }
    onLoading?.(false);
    handleClose();
  };

  return (
    <MenuItem disabled={loading} onClick={handleResendInvitation}>
      <ListItemIcon>
        {loading ? <CircularProgress size={16} thickness={5} /> : <MdsIcon fontSize="small" icon={MdsRedoXs} />}
      </ListItemIcon>
      <ListItemText>{t("Attendance.resendInvitation")}</ListItemText>
    </MenuItem>
  );
};
